module.exports = __webpack_public_path__ + "img/nav3-active.dba0399d.png";